import { render } from "./ListaDeAgendamentosCommonView.vue?vue&type=template&id=1bc3a70a"
import script from "./ListaDeAgendamentosCommonView.vue?vue&type=script&lang=js"
export * from "./ListaDeAgendamentosCommonView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__